// extracted by mini-css-extract-plugin
export var activityContainer = "_hm-0";
export var typingIndicatorContainer = "_hm-1";
export var typingIndicatorDot = "_hm-2";
export var wave = "_hm-3";